export const styles = {
  container: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  containerDesktop: {
    gridTemplateColumns: 'repeat(4, 1fr)',
  },
};
